import { useState, useEffect, useCallback } from "react";
import api from "../api";

const ORANGE = "#EE6A1A";
const VERM = "#e2445c";
const VERDE = "#1D9E75";
const AZUL = "#579bfc";

const dois = (n) => String(n).padStart(2, "0");
const iso = (d) => d.getFullYear() + "-" + dois(d.getMonth() + 1) + "-" + dois(d.getDate());
const curto = (d) => { const x = new Date(d); return dois(x.getDate()) + "/" + dois(x.getMonth() + 1); };
const cortaHora = (d) => { const x = new Date(d); return dois(x.getHours()) + ":" + dois(x.getMinutes()); };
const reais = (v) => "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const reaisCurto = (v) => "R$ " + Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: 0 });

const paraWhats = (tel) => {
  const so = String(tel || "").replace(/\D/g, "");
  if (!so) return "";
  return so.length <= 11 ? "55" + so : so;
};

const PERIODOS = [
  ["mes", "Este mês"],
  ["passado", "Mês passado"],
  ["90", "Últimos 90 dias"],
  ["ano", "Este ano"],
];

const intervaloDe = (id) => {
  const h = new Date();
  if (id === "passado") return [new Date(h.getFullYear(), h.getMonth() - 1, 1), new Date(h.getFullYear(), h.getMonth(), 0)];
  if (id === "90") return [new Date(h.getTime() - 89 * 86400000), h];
  if (id === "ano") return [new Date(h.getFullYear(), 0, 1), h];
  return [new Date(h.getFullYear(), h.getMonth(), 1), new Date(h.getFullYear(), h.getMonth() + 1, 0)];
};

function Kpi({ titulo, valor, sub, cor }) {
  return (
    <div style={{ background: "var(--card-bg)", border: "1px solid var(--border-color)", borderRadius: 14, padding: "18px 20px", flex: "1 1 190px", minWidth: 190 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".05em" }}>{titulo}</div>
      <div style={{ fontSize: 26, fontWeight: 800, color: cor || "var(--text-primary)", margin: "8px 0 2px", lineHeight: 1.1 }}>{valor}</div>
      <div style={{ fontSize: 12, color: "var(--text-secondary)" }}>{sub}</div>
    </div>
  );
}

function Barras({ titulo, dados, vazio }) {
  const maior = dados.reduce((m, d) => Math.max(m, d.valor || 0, 0), 0) || 1;
  return (
    <div style={{ background: "var(--card-bg)", border: "1px solid var(--border-color)", borderRadius: 14, padding: 20, flex: "1 1 330px", minWidth: 300 }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-primary)", marginBottom: 14 }}>{titulo}</div>
      {!dados.length && <div style={{ fontSize: 13, color: "var(--text-muted)" }}>{vazio}</div>}
      {dados.map((d) => (
        <div key={d.rotulo} style={{ marginBottom: 11 }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12.5, marginBottom: 4 }}>
            <span style={{ color: "var(--text-primary)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "65%" }}>{d.rotulo}</span>
            <span style={{ color: "var(--text-secondary)", whiteSpace: "nowrap" }}>{d.faltas} · {reaisCurto(d.valor)}</span>
          </div>
          <div style={{ height: 7, borderRadius: 4, background: "var(--hover-bg)", overflow: "hidden" }}>
            <div style={{ height: "100%", width: Math.max(4, ((d.valor || 0) / maior) * 100) + "%", background: VERM, borderRadius: 4 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default function Faltas() {
  const hoje = new Date();
  const [periodo, setPeriodo] = useState("mes");
  const [de, setDe] = useState(iso(new Date(hoje.getFullYear(), hoje.getMonth(), 1)));
  const [ate, setAte] = useState(iso(new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0)));
  const [d, setD] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");
  const [soAbertas, setSoAbertas] = useState(false);

  const escolher = (id) => {
    const [a, b] = intervaloDe(id);
    setPeriodo(id); setDe(iso(a)); setAte(iso(b));
  };

  const carregar = useCallback(() => {
    setCarregando(true);
    api.get("/faltas", { params: { de, ate } })
      .then(({ data }) => { setD(data); setErro(""); })
      .catch((e) => setErro((e.response && e.response.data && e.response.data.message) || "Não foi possível carregar."))
      .finally(() => setCarregando(false));
  }, [de, ate]);
  useEffect(() => { carregar(); }, [carregar]);

  const chamar = (f) => {
    const fone = paraWhats(f.telefone);
    if (!fone) return window.alert("Esse paciente não tem telefone cadastrado no horário.");
    const msg = "Olá " + (f.pacienteNome || "").split(" ")[0] + "! Sentimos sua falta no dia " + curto(f.inicio) +
      (f.procedimento ? " (" + f.procedimento + ")" : "") + ". Quer que eu remarque? Tenho horários essa semana.";
    window.open("https://wa.me/" + fone + "?text=" + encodeURIComponent(msg), "_blank");
  };

  const card = { background: "var(--card-bg)", border: "1px solid var(--border-color)", borderRadius: 14, padding: 20 };
  const btnPer = (ativo) => ({ padding: "8px 14px", borderRadius: 9, border: ativo ? 0 : "1px solid var(--border-color)", background: ativo ? ORANGE : "transparent", color: ativo ? "#fff" : "var(--text-secondary)", fontWeight: 700, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit" });
  const inpData = { padding: "8px 10px", borderRadius: 9, border: "1px solid var(--border-color)", background: "var(--input-bg)", color: "var(--text-primary)", fontSize: 12.5, fontFamily: "inherit", outline: "none" };
  const th = { textAlign: "left", fontSize: 11, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".04em", padding: "0 10px 9px" };
  const td = { fontSize: 13, color: "var(--text-primary)", padding: "11px 10px", borderTop: "1px solid var(--border-color)" };

  const r = d ? d.resumo : null;
  const c = d ? d.confirmacao : null;
  const listaVista = d ? (soAbertas ? d.lista.filter((f) => !f.remarcadoPara) : d.lista) : [];
  const diferenca = c && c.naoConfirmados.total && c.confirmados.total ? Math.round((c.naoConfirmados.taxa - c.confirmados.taxa) * 10) / 10 : null;

  return (
    <div style={{ padding: 24, fontFamily: "'Inter',-apple-system,sans-serif", background: "var(--page-bg)", minHeight: "100vh" }}>
      <div style={{ marginBottom: 18 }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "var(--text-primary)" }}>Faltas</h1>
        <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--text-muted)" }}>Quanto as faltas custaram no período e quanto já voltou para a agenda.</p>
      </div>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 18 }}>
        {PERIODOS.map(([id, rot]) => <button key={id} onClick={() => escolher(id)} style={btnPer(periodo === id)}>{rot}</button>)}
        <span style={{ width: 1, height: 22, background: "var(--border-color)", margin: "0 4px" }} />
        <input type="date" value={de} onChange={(e) => { setPeriodo(""); setDe(e.target.value); }} style={inpData} />
        <span style={{ fontSize: 12.5, color: "var(--text-muted)" }}>até</span>
        <input type="date" value={ate} onChange={(e) => { setPeriodo(""); setAte(e.target.value); }} style={inpData} />
      </div>

      {erro && <div style={{ ...card, color: VERM, fontSize: 13 }}>{erro}</div>}
      {carregando && !d && <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Carregando…</div>}

      {d && (
        <>
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 16 }}>
            <Kpi titulo="Perdido com faltas" valor={reais(r.valorPerdido)} sub={r.faltas + (r.faltas === 1 ? " falta" : " faltas") + " no período"} cor={VERM} />
            <Kpi titulo="Já recuperado" valor={reais(r.valorRecuperado)} sub={r.faltasRecuperadas + " remarcadas e atendidas"} cor={VERDE} />
            <Kpi titulo="Remarcado, a atender" valor={reais(r.valorRemarcado - r.valorRecuperado)} sub={(r.faltasRemarcadas - r.faltasRecuperadas) + " com horário novo marcado"} cor={AZUL} />
            <Kpi titulo="Prejuízo que ficou" valor={reais(r.valorPerdidoLiquido)} sub={(r.faltas - r.faltasRemarcadas) + " sem remarcar até agora"} cor={VERM} />
            <Kpi titulo="Taxa de falta" valor={r.taxaFalta + "%"} sub={r.atendidos + " atendidos · " + r.faltas + " faltas"} />
          </div>

          {c && (c.confirmados.total > 0 || c.naoConfirmados.total > 0) && (
            <div style={{ ...card, marginBottom: 16 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-primary)", marginBottom: 4 }}>O que a confirmação pelo WhatsApp muda</div>
              <div style={{ fontSize: 12.5, color: "var(--text-muted)", marginBottom: 14 }}>Comparando quem respondeu a confirmação com quem nunca confirmou.</div>
              <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
                <div style={{ flex: "1 1 220px", padding: "14px 16px", borderRadius: 11, background: "var(--hover-bg)" }}>
                  <div style={{ fontSize: 12, color: "var(--text-secondary)", marginBottom: 6 }}>Confirmaram o horário</div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: VERDE }}>{c.confirmados.taxa}% faltaram</div>
                  <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 3 }}>{c.confirmados.faltas} de {c.confirmados.total} horários</div>
                </div>
                <div style={{ flex: "1 1 220px", padding: "14px 16px", borderRadius: 11, background: "var(--hover-bg)" }}>
                  <div style={{ fontSize: 12, color: "var(--text-secondary)", marginBottom: 6 }}>Não confirmaram</div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: VERM }}>{c.naoConfirmados.taxa}% faltaram</div>
                  <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 3 }}>{c.naoConfirmados.faltas} de {c.naoConfirmados.total} horários</div>
                </div>
              </div>
              {diferenca !== null && diferenca > 0 && (
                <div style={{ marginTop: 13, fontSize: 13, color: "var(--text-secondary)", lineHeight: 1.5 }}>
                  Quem não confirma falta <b style={{ color: VERM }}>{diferenca} pontos</b> a mais. Mandar a confirmação no dia anterior é o jeito mais barato de derrubar esse número.
                </div>
              )}
            </div>
          )}

          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 16 }}>
            <Barras titulo="Procedimentos que mais somem" dados={d.porProcedimento} vazio="Nenhuma falta no período." />
            <Barras titulo="Por profissional" dados={d.porProfissional} vazio="Nenhuma falta no período." />
            <Barras titulo="Dia da semana" dados={d.porDiaSemana} vazio="Nenhuma falta no período." />
          </div>

          {d.reincidentes.length > 0 && (
            <div style={{ ...card, marginBottom: 16 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-primary)", marginBottom: 4 }}>Faltaram mais de uma vez</div>
              <div style={{ fontSize: 12.5, color: "var(--text-muted)", marginBottom: 12 }}>Para esses, vale pedir confirmação por telefone ou cobrar sinal.</div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {d.reincidentes.map((p) => (
                  <span key={p.rotulo} style={{ fontSize: 12.5, fontWeight: 600, color: "var(--text-primary)", background: "var(--hover-bg)", borderRadius: 8, padding: "7px 12px" }}>
                    {p.rotulo} <span style={{ color: VERM }}>· {p.faltas}x</span> <span style={{ color: "var(--text-muted)" }}>· {reaisCurto(p.valor)}</span>
                  </span>
                ))}
              </div>
            </div>
          )}

          <div style={card}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10, marginBottom: 14 }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-primary)" }}>Faltas do período</div>
                <div style={{ fontSize: 12.5, color: "var(--text-muted)", marginTop: 3 }}>Chame no WhatsApp quem ainda não remarcou.</div>
              </div>
              <button onClick={() => setSoAbertas(!soAbertas)} style={btnPer(soAbertas)}>{soAbertas ? "Mostrando só quem não remarcou" : "Ver só quem não remarcou"}</button>
            </div>

            {!listaVista.length && <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Nenhuma falta aqui. Ótimo sinal.</div>}

            {listaVista.length > 0 && (
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead><tr>
                    <th style={th}>Quando</th><th style={th}>Paciente</th><th style={th}>Procedimento</th>
                    <th style={th}>Profissional</th><th style={{ ...th, textAlign: "right" }}>Valor</th>
                    <th style={th}>Situação</th><th style={th}></th>
                  </tr></thead>
                  <tbody>
                    {listaVista.map((f) => (
                      <tr key={f._id}>
                        <td style={{ ...td, whiteSpace: "nowrap", color: "var(--text-secondary)" }}>{curto(f.inicio)} · {cortaHora(f.inicio)}</td>
                        <td style={{ ...td, fontWeight: 600 }}>{f.pacienteNome}</td>
                        <td style={{ ...td, color: "var(--text-secondary)" }}>{f.procedimento || "—"}</td>
                        <td style={{ ...td, color: "var(--text-secondary)" }}>{f.profissionalNome || "—"}</td>
                        <td style={{ ...td, textAlign: "right", whiteSpace: "nowrap", color: f.valor ? "var(--text-primary)" : "var(--text-muted)" }}>{f.valor ? reais(f.valor) : "—"}</td>
                        <td style={{ ...td, whiteSpace: "nowrap" }}>
                          {f.recuperado
                            ? <span style={{ fontSize: 11.5, fontWeight: 700, color: VERDE, background: VERDE + "18", borderRadius: 6, padding: "3px 8px" }}>Recuperado</span>
                            : f.remarcadoPara
                              ? <span style={{ fontSize: 11.5, fontWeight: 700, color: AZUL, background: AZUL + "18", borderRadius: 6, padding: "3px 8px" }}>Remarcado {curto(f.remarcadoPara)}</span>
                              : <span style={{ fontSize: 11.5, fontWeight: 700, color: VERM, background: VERM + "18", borderRadius: 6, padding: "3px 8px" }}>Sem remarcar</span>}
                        </td>
                        <td style={{ ...td, textAlign: "right" }}>
                          {!f.remarcadoPara && <button onClick={() => chamar(f)} style={{ ...btnPer(false), padding: "6px 12px", fontSize: 12 }}>Chamar</button>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {d.semValor > 0 && (
              <div style={{ marginTop: 14, fontSize: 12.5, color: "var(--text-muted)", lineHeight: 1.5 }}>
                {d.semValor} {d.semValor === 1 ? "falta está" : "faltas estão"} sem valor. O valor vem do campo Valor do agendamento ou do preço do procedimento no catálogo — preencha um dos dois para o cálculo ficar completo.
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
